module.exports = __webpack_public_path__ + "img/p19.54a96e6b.png";